import { useState, useEffect } from 'react';
import api from '../services/authService';

// Admin-edited content (Config tab in the admin portal). Fetched once per page
// load and shared; an empty/missing field means "use the built-in default",
// so the app renders correctly if the request fails.
//
// The last response is cached in localStorage and used as the initial value so
// custom icons/text don't flash the defaults on every page load.
const CACHE_KEY = 'site_config_cache';

const readCache = () => {
  try {
    return JSON.parse(localStorage.getItem(CACHE_KEY)) || {};
  } catch (e) {
    return {};
  }
};

const writeCache = (cfg) => {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(cfg));
  } catch (e) {
    // storage unavailable (private mode etc.) — fine, just no cache
  }
};

let configPromise = null;

const loadSiteConfig = () => {
  if (!configPromise) {
    configPromise = api
      .get('/site-config')
      .then((res) => {
        const cfg = res.data || {};
        writeCache(cfg);
        return cfg;
      })
      .catch((err) => {
        configPromise = null;
        console.error('Failed to load site config:', err);
        return null;
      });
  }
  return configPromise;
};

export const useSiteConfig = () => {
  const [siteConfig, setSiteConfig] = useState(readCache);

  useEffect(() => {
    let cancelled = false;
    loadSiteConfig().then((cfg) => {
      if (!cancelled && cfg) setSiteConfig(cfg);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return siteConfig;
};
